import { useViewerIsSuperAdmin } from "@/lib/rights/use-viewer-is-baback-team";
import { useOpenAdminPanel } from "@/lib/use-open-admin-panel";

/** Super admins only: this return in the admin panel (address asked of the backend at the click). */
export default function AdminPanelShortcut({ returnId }: { returnId: string }) {
  const isSuperAdmin = useViewerIsSuperAdmin();
  const openAdminPanel = useOpenAdminPanel();
  if (!isSuperAdmin) return null;

  return (
    <button
      type="button"
      title="Admin panel"
      aria-label="Admin panel (nouvel onglet)"
      onClick={() =>
        void openAdminPanel(
          `/returns/search?returnId=${encodeURIComponent(returnId)}`,
        )
      }
      className="flex size-8 cursor-pointer items-center justify-center rounded-md hover:bg-accent"
    >
      <img
        src="/admin-panel-logo.png"
        alt=""
        className="size-5 rounded-[4px]"
      />
    </button>
  );
}
